<template>
  <div class="options">
    <div class="ul dis_f_l">
      <div v-if="name">
        <div class="liTitle" v-if="isOpen">{{ name }}</div>
        <div class="liTitleActive" v-else>{{ name }}</div>
      </div>
      <div class="liContent dis_f_l_c dis_f_w">
        <div
          class="liZi dis_f_c_c hand"
          :class="{ classActice: liActice }"
          @click="all"
          v-if="isAll"
        >
          全部
        </div>
        <div
          class="liZi dis_f_c_c hand"
          :class="{ classActice: item.liActice == true }"
          v-for="(item, index) in array"
          :key="index"
          @click="activeIndex(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    // 列表
    list: {
      type: Array,
      default: null,
    },
    // 名字 空的化不显示
    name: {
      type: String,
      default: "",
    },
    // 不显示全部
    isAll: {
      type: Boolean,
      default: true,
    },
    // 自动展开前面的名字
    isOpen: {
      type: Boolean,
      default: true,
    },
    // 下margin
    isMargin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      liActice: false, //全部类似重置
      array: [], //数组
    };
  },
  components: {},
  watch: {},
  computed: {},
  mounted() {
    // 深克隆
    let list = JSON.parse(JSON.stringify(this.list));
    list.forEach((arr) => {
      arr.liActice = false;
    });
    this.array = JSON.parse(JSON.stringify(list));
    // 下magin-bottom
    this.$nextTick(() => {
      if (this.isMargin) {
        console.log("4654564564");
        let liZIAll = document.querySelectorAll(".liZi");
        for (let i = 0; i < liZIAll.length; i++) {
          liZIAll[i].style.marginBottom = "0px";
        }
      }
    });
  },
  created() {},
  methods: {
    // 全部
    all() {
      this.array.forEach((arr) => {
        arr.liActice = false;
      });
      this.liActice = true; //全部
      this.$emit("listMethods", { array: [] });
    },
    // 选项
    activeIndex(item) {
      this.liActice = false; //全部
      item.liActice = !item.liActice; //选中
      let list = [];
      this.array.forEach((arr) => {
        if (arr.liActice == true) {
          list.push(arr);
        }
      });
      this.$emit("listMethods", { array: list });
    },
    // 大于10位的下边距隐藏
    maginNone() {
      console.log(name);
      let liZi = document.querySelectorAll(".liZi");
      console.log(liZi);
    },
  },
};
</script>
<style lang="scss" scoped>
$colorTitle: #272a31;
.options {
  width: 100%;
  .ul {
    .liTitle {
      width: 48px;
      height: 30px;
      line-height: 30px;
      display: inline-block;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: bold;
      color: $colorTitle;
      margin-right: 20px;
      text-align: justify;
      vertical-align: top;
      &::after {
        display: inline-block;
        width: 100%;
        content: "";
        height: 0;
      }
    }
    .liTitleActive {
      height: 30px;
      line-height: 30px;
      display: inline-block;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: bold;
      color: $colorTitle;
      margin-right: 20px;
    }
    .liContent {
      .liZi {
        width: 94px;
        height: 30px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #45484e;
        border-radius: 4px;
        margin-right: 10px;
        margin-bottom: 4px;
      }
      .liZi:nth-child(n + 11) {
        margin-bottom: 0 !important;
      }
      .liZi:hover {
        color: var(--themeColor);
      }
      .classActice {
        background-color: var(--themeBg);
        font-weight: bold;
        color: var(--themeColor);
        transition: all 0.2s;
      }
    }
  }
}
</style>
    
